if (!customElements.get('product-tabs')) {
  class ProductTabs extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (!this.tabs.length || this.tabs.length !== this.panels.length) return;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activateTab(tab, true));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      const initiallyActiveTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
      this.activateTab(initiallyActiveTab, false);
    }

    activateTab(activeTab, moveFocus) {
      this.tabs.forEach((tab, index) => {
        const isActive = tab === activeTab;
        const panel = this.panels[index];

        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;

        if (panel) panel.hidden = !isActive;
      });

      if (moveFocus) activeTab.focus();
    }

    onKeydown(event, currentIndex) {
      let nextIndex = currentIndex;

      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          nextIndex = (currentIndex + 1) % this.tabs.length;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = this.tabs.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.activateTab(this.tabs[nextIndex], true);
    }
  }

  customElements.define('product-tabs', ProductTabs);
}
